import styledNormalize from 'styled-normalize'

import theme from './theme'
import fonts from './fonts'

import 'swiper/swiper-bundle.min.css'

export default `
  ${styledNormalize}

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: ${theme.bodyFont};
    -webkit-font-smoothing: antialiased;
  }

  ul {
  margin-bottom: 20px;
  }
  p {
    margin: 0;
    margin-bottom: 20px;
  }

  h1, h2, h3, h4, h5 {
    font-weight: 300;
  }

  h1 {
    font-size: 2.5em;
    font-weight: 350;
    line-height: 45px;
  }

  h2 {
    font-size: 35px;
    line-height: 1.2;
    margin-bottom: 30px;
    font-weight: 350;
  }

  h3 {
    font-size: 1.414em;
    line-height: 20px;
    font-weight: 350;
  }

  * {
    box-sizing: border-box;
  }

  img, svg {
    display: block;
  }

  a {
    text-decoration: none;
    color: ${theme.colors.primary};
  }

  /**
   * Bootstrap utils
   **/

  .noGutters {
    margin-right: 0;
    margin-left: 0;

    > div {
      padding-right: 0;
      padding-left: 0;
    }
  }

   /**
   * Tweak container padding on small devices
   **/
  [data-name=container-fluid] {

    @media(max-width: ${theme.grid.breakpoints.xs}px) {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .text-rtl {
    direction: rtl;
  }

  /**
   * Scroll locking util for overlays and modals 
   **/
  body.scroll-lock {
    overflow: hidden;
  }

  ${fonts}
`



// WEBPACK FOOTER //
// ./src/ui/styles/global.js